import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getCurrentBuilding,
  getCurrentPage,
  getWorkOrders,
} from 'selectors/admin/buildings/buildings';
import { loadWorkOrdersRequest } from 'actions/admin/buildings/buildings';
import ResourceWorkOrders from 'components/shared/work-orders/ResourceWorkOrders';

class BuildingDetailsWorkOrders extends Component {
  render() {
    const { currentBuilding, currentPage, workOrders } = this.props;
    return (
      <ResourceWorkOrders
        resource={currentBuilding}
        workOrders={workOrders}
        currentPage={currentPage}
        loadWorkOrdersRequest={loadWorkOrdersRequest}
      />
    );
  }
}

export default connect((state) => {
  return {
    currentBuilding: getCurrentBuilding(state),
    currentPage: getCurrentPage(state),
    workOrders: getWorkOrders(state),
  };
})(BuildingDetailsWorkOrders);



// WEBPACK FOOTER //
// ./src/components/admin/buildings/BuildingDetailsWorkOrders.js